import { SvgIconProps } from "../types";

export const SvgIcon = ({
  src,
  width,
  height,
  style,
  alt = "",
  loading = "eager",
  fetchPriority = "auto",
}: SvgIconProps) => {
  const isImage = /\.(png|jpe?g|webp)$/i.test(src);
  const path = isImage ? `/img/${src}` : `/img/svg/${src}`;
  return (
    <img
      src={path}
      alt={alt}
      width={width}
      height={height}
      style={style}
      loading={loading}
      decoding="async"
      // React 17 types predate fetchpriority, so it goes through as a raw attribute.
      {...{ fetchpriority: fetchPriority }}
    />
  );
};
